var map = {
	"./abkhazia.svg": 333,
	"./afghanistan.svg": 334,
	"./aland-islands.svg": 335,
	"./albania.svg": 336,
	"./algeria.svg": 337,
	"./american-samoa.svg": 338,
	"./andorra.svg": 339,
	"./angola.svg": 340,
	"./anguilla.svg": 341,
	"./antigua-and-barbuda.svg": 342,
	"./ar.svg": 343,
	"./argentina.svg": 344,
	"./armenia.svg": 345,
	"./aruba.svg": 346,
	"./australia.svg": 205,
	"./austria.svg": 347,
	"./azerbaijan.svg": 212,
	"./azores-islands.svg": 348,
	"./bahamas.svg": 349,
	"./bahrain.svg": 350,
	"./balearic-islands.svg": 351,
	"./bangladesh.svg": 352,
	"./barbados.svg": 353,
	"./basque-country.svg": 354,
	"./belarus.svg": 355,
	"./belgium.svg": 215,
	"./belize.svg": 356,
	"./benin.svg": 357,
	"./bermuda.svg": 358,
	"./bhutan-1.svg": 359,
	"./bhutan.svg": 360,
	"./bolivia.svg": 361,
	"./bonaire.svg": 362,
	"./bosnia-and-herzegovina.svg": 363,
	"./botswana.svg": 364,
	"./brazil.svg": 365,
	"./british-columbia.svg": 366,
	"./british-indian-ocean-territory.svg": 367,
	"./british-virgin-islands.svg": 368,
	"./brunei.svg": 369,
	"./bulgaria.svg": 370,
	"./burkina-faso.svg": 371,
	"./burundi.svg": 372,
	"./cambodia.svg": 373,
	"./cameroon.svg": 374,
	"./canada.svg": 206,
	"./canary-islands.svg": 375,
	"./cape-verde.svg": 376,
	"./cayman-islands.svg": 377,
	"./central-african-republic.svg": 378,
	"./ceuta.svg": 379,
	"./chad.svg": 380,
	"./chile.svg": 381,
	"./china.svg": 382,
	"./christmas-island.svg": 383,
	"./cocos-island.svg": 384,
	"./colombia.svg": 385,
	"./comoros.svg": 386,
	"./cook-islands.svg": 387,
	"./corsica.svg": 388,
	"./costa-rica.svg": 389,
	"./croatia.svg": 390,
	"./cuba.svg": 391,
	"./curacao.svg": 392,
	"./cyprus.svg": 393,
	"./czech-republic.svg": 394,
	"./democratic-republic-of-congo.svg": 395,
	"./denmark.svg": 396,
	"./djibouti.svg": 397,
	"./dominica.svg": 398,
	"./dominican-republic.svg": 399,
	"./east-timor.svg": 400,
	"./ecuador.svg": 401,
	"./egypt.svg": 402,
	"./en.svg": 403,
	"./england.svg": 404,
	"./equatorial-guinea.svg": 405,
	"./eritrea.svg": 406,
	"./estonia.svg": 407,
	"./ethiopia.svg": 408,
	"./european-union.svg": 409,
	"./falkland-islands.svg": 410,
	"./faroe-islands.svg": 411,
	"./fiji.svg": 412,
	"./finland.svg": 413,
	"./france.svg": 209,
	"./french-polynesia.svg": 414,
	"./gabon.svg": 415,
	"./galapagos-islands.svg": 416,
	"./gambia.svg": 417,
	"./georgia.svg": 418,
	"./germany.svg": 419,
	"./ghana.svg": 420,
	"./gibraltar.svg": 421,
	"./greece.svg": 422,
	"./greenland.svg": 423,
	"./grenada.svg": 424,
	"./guam.svg": 425,
	"./guatemala.svg": 426,
	"./guernsey.svg": 427,
	"./guinea-bissau.svg": 428,
	"./guinea.svg": 429,
	"./guyana.svg": 430,
	"./haiti.svg": 431,
	"./hawaii.svg": 432,
	"./honduras.svg": 433,
	"./hong-kong.svg": 434,
	"./hungary.svg": 435,
	"./iceland.svg": 436,
	"./india.svg": 201,
	"./indonesia.svg": 437,
	"./iran.svg": 438,
	"./iraq.svg": 439,
	"./ireland.svg": 440,
	"./isle-of-man.svg": 441,
	"./israel.svg": 243,
	"./italy.svg": 442,
	"./ivory-coast.svg": 443,
	"./jamaica.svg": 444,
	"./japan.svg": 213,
	"./jersey.svg": 445,
	"./jordan.svg": 446,
	"./kazakhstan.svg": 447,
	"./kenya.svg": 448,
	"./kiribati.svg": 449,
	"./kosovo.svg": 450,
	"./kuwait.svg": 451,
	"./kyrgyzstan.svg": 452,
	"./laos.svg": 453,
	"./latvia.svg": 454,
	"./lebanon.svg": 455,
	"./lesotho.svg": 456,
	"./liberia.svg": 457,
	"./libya.svg": 458,
	"./liechtenstein.svg": 459,
	"./lithuania.svg": 460,
	"./luxembourg.svg": 461,
	"./macao.svg": 462,
	"./madagascar.svg": 463,
	"./madeira.svg": 464,
	"./malawi.svg": 465,
	"./malaysia.svg": 466,
	"./maldives.svg": 467,
	"./mali.svg": 468,
	"./malta.svg": 469,
	"./marshall-island.svg": 470,
	"./martinique.svg": 471,
	"./mauritania.svg": 472,
	"./mauritius.svg": 473,
	"./melilla.svg": 474,
	"./mexico.svg": 475,
	"./micronesia.svg": 476,
	"./moldova.svg": 477,
	"./monaco.svg": 478,
	"./mongolia.svg": 479,
	"./montenegro.svg": 480,
	"./montserrat.svg": 481,
	"./morocco.svg": 482,
	"./mozambique.svg": 483,
	"./myanmar.svg": 484,
	"./namibia.svg": 485,
	"./nato.svg": 486,
	"./nauru.svg": 487,
	"./nepal.svg": 488,
	"./netherlands.svg": 489,
	"./new-zealand.svg": 214,
	"./nicaragua.svg": 490,
	"./niger.svg": 491,
	"./nigeria.svg": 492,
	"./niue.svg": 493,
	"./norfolk-island.svg": 494,
	"./north-korea.svg": 495,
	"./northen-cyprus.svg": 496,
	"./northern-marianas-islands.svg": 497,
	"./norway.svg": 498,
	"./oman.svg": 499,
	"./orkney-islands.svg": 500,
	"./ossetia.svg": 501,
	"./pakistan.svg": 202,
	"./palau.svg": 502,
	"./palestine.svg": 503,
	"./panama.svg": 504,
	"./papua-new-guinea.svg": 505,
	"./paraguay.svg": 506,
	"./peru.svg": 507,
	"./philippines.svg": 508,
	"./pitcairn-islands.svg": 509,
	"./portugal.svg": 510,
	"./puerto-rico.svg": 511,
	"./qatar.svg": 512,
	"./rapa-nui.svg": 513,
	"./republic-of-macedonia.svg": 514,
	"./republic-of-poland.svg": 515,
	"./republic-of-the-congo.svg": 516,
	"./romania.svg": 517,
	"./russia.svg": 203,
	"./rwanda.svg": 518,
	"./saba-island.svg": 519,
	"./saint-kitts-and-nevis.svg": 520,
	"./salvador.svg": 521,
	"./samoa.svg": 522,
	"./san-marino.svg": 523,
	"./sao-tome-and-principe.svg": 524,
	"./sardinia.svg": 525,
	"./saudi-arabia.svg": 526,
	"./scotland.svg": 527,
	"./senegal.svg": 528,
	"./serbia.svg": 529,
	"./seychelles.svg": 530,
	"./sierra-leone.svg": 531,
	"./singapore.svg": 532,
	"./sint-eustatius.svg": 533,
	"./sint-maarten.svg": 534,
	"./slovakia.svg": 535,
	"./slovenia.svg": 536,
	"./solomon-islands.svg": 537,
	"./somalia.svg": 538,
	"./somaliland.svg": 539,
	"./south-africa.svg": 208,
	"./south-korea.svg": 540,
	"./south-sudan.svg": 541,
	"./spain.svg": 542,
	"./sri-lanka.svg": 543,
	"./st-barts.svg": 544,
	"./st-lucia.svg": 545,
	"./st-vincent-and-the-grenadines.svg": 546,
	"./sudan.svg": 547,
	"./suriname.svg": 548,
	"./swaziland.svg": 549,
	"./sweden.svg": 550,
	"./switzerland.svg": 204,
	"./syria.svg": 551,
	"./taiwan.svg": 552,
	"./tajikistan.svg": 553,
	"./tanzania.svg": 554,
	"./thailand.svg": 555,
	"./tibet.svg": 556,
	"./togo.svg": 557,
	"./tokelau.svg": 558,
	"./tonga.svg": 559,
	"./tr.svg": 560,
	"./transnistria.svg": 561,
	"./trinidad-and-tobago.svg": 562,
	"./tunisia.svg": 563,
	"./turkey.svg": 564,
	"./turkmenistan.svg": 565,
	"./turks-and-caicos.svg": 566,
	"./tuvalu.svg": 567,
	"./uganda.svg": 568,
	"./ukraine.svg": 207,
	"./united-arab-emirates.svg": 211,
	"./united-kingdom.svg": 210,
	"./united-nations.svg": 569,
	"./united-states-of-america.svg": 570,
	"./uruguay.svg": 571,
	"./uzbekistn.svg": 572,
	"./vanuatu.svg": 573,
	"./vatican-city.svg": 574,
	"./venezuela.svg": 575,
	"./vietnam.svg": 576,
	"./virgin-islands.svg": 577,
	"./wales.svg": 578,
	"./western-sahara.svg": 579,
	"./yemen.svg": 580,
	"./zambia.svg": 581,
	"./zimbabwe.svg": 582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 905;